// extracted by mini-css-extract-plugin
export default {"container":"Activities_container__ngTVv","number":"Activities_number__PNsuK","total":"Activities_total__XHOEP"};